import OfficerIndex from '@/views/Officer/index';
import Officers from '@/views/Officer/Officers';
import OfficerDetails from '@/views/Officer/OfficerDetails';
import OfficerDetailsPerformance from '@/views/Officer/OfficerDetailsPerformance';
import OfficerDetailsOverdueLoans from '@/views/Officer/OfficerDetailsOverdueLoans';
import OfficerDetailsActiveLoans from '@/views/Officer/OfficerDetailsActiveLoans';
import OfficerDetailsNotes from '@/views/Officer/OfficerDetailsNotes';
import { requiresOfficersAccess } from '@/router/helpers';

export default [
  {
    path: '/officers',
    component: OfficerIndex,
    beforeEnter: requiresOfficersAccess,
    meta: {
      group: 'officers',
      roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER'],
      title: 'Ажилчид',
    },
    children: [
      {
        path: '',
        name: 'Officers',
        component: Officers,
      },
      {
        path: ':officerId',
        component: OfficerDetails,
        children: [
          {
            path: '',
            name: 'OfficerDetails',
            component: OfficerDetailsPerformance,
          },
          {
            path: 'overdue-loans',
            name: 'OfficerDetailsOverdueLoans',
            component: OfficerDetailsOverdueLoans,
          },
          {
            path: 'active-loans',
            name: 'OfficerDetailsActiveLoans',
            component: OfficerDetailsActiveLoans,
          },
          {
            path: 'notes',
            name: 'OfficerDetailsNotes',
            component: OfficerDetailsNotes,
          },
        ],
      },
    ],
  },
];
